module.exports = __webpack_public_path__ + "img/step3.14ca861d.png";